/*专家指导系统*/

/*主容器文件*/
const zjzd_ = () => import("../../../studio/sub_systems/zjzd_system/index");
/*首页*/
const zjzd_index_ = () => import("../../../studio/sub_systems/zjzd_system/index_page/index_page_main");


/*专家管理*/
const zjzd_index_zjgl = () => import("../../../studio/sub_systems/zjzd_system/index_page/zjgl/index");
/*示范案例*/
const zjzd_index_sfal = () => import("../../../studio/sub_systems/zjzd_system/index_page/sfal/index");
/**首页 */
const zjzd_index_homePage = () => import("../../../studio/sub_systems/zjzd_system/index_page/homePage/index");
export default [
  {
    path: '/zjzdxt',
    name: '专家指导系统',
    redirect: '/zjzdxt/index',
    component: zjzd_,
    children: [
      {
        path: '/zjzdxt/index',
        redirect: '/zjzdxt/index/zjgl',
        name: '首页',
        component: zjzd_index_,
        children: [
          {
            path: '/zjzdxt/index/zjgl',
            name: '专家管理',
            component: zjzd_index_zjgl,
          },
          {
            path: '/zjzdxt/index/sfal',
            name: '示范案例',
            component: zjzd_index_sfal,
          },
          {
            path: '/zjzdxt/index/homePage',
            name: '首页',
            component: zjzd_index_homePage,
          }
        ]
      },

    ]
  },

]



// WEBPACK FOOTER //
// ./src/router/modules/zjzd/zjzd_system_page.js